import { createElementBlock as o, openBlock as r, createElementVNode as t, normalizeClass as s } from "vue";
const l = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-familyfriendly"
};
function n(i, e) {
  return r(), o("svg", l, [
    e[0] || (e[0] = t("path", {
      d: "M1 14V6C1 4.67392 1.52678 3.40215 2.46447 2.46447C3.40215 1.52678 4.67392 1 6 1H14C15.3261 1 16.5979 1.52678 17.5355 2.46447C18.4732 3.40215 19 4.67392 19 6V14C19 15.3261 18.4732 16.5979 17.5355 17.5355C16.5979 18.4732 15.3261 19 14 19H6C4.67392 19 3.40215 18.4732 2.46447 17.5355C1.52678 16.5979 1 15.3261 1 14Z",
      stroke: "#555555",
      class: "svg__stroke--medium-grey",
      "stroke-width": "1.5"
    }, null, -1)),
    e[1] || (e[1] = t("path", {
      d: "M14.5 12.5C14.5 12.5 13 14.5 10 14.5C7 14.5 5.5 12.5 5.5 12.5",
      stroke: "#555555",
      class: "svg__stroke--medium-grey",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)),
    t("path", {
      d: "M6.50012 8C6.36751 8 6.24034 7.94732 6.14657 7.85355C6.0528 7.75979 6.00012 7.63261 6.00012 7.5C6.00012 7.36739 6.0528 7.24021 6.14657 7.14645C6.24034 7.05268 6.36751 7 6.50012 7C6.63273 7 6.75991 7.05268 6.85368 7.14645C6.94744 7.24021 7.00012 7.36739 7.00012 7.5C7.00012 7.63261 6.94744 7.75979 6.85368 7.85355C6.75991 7.94732 6.63273 8 6.50012 8ZM13.5001 8C13.3675 8 13.2403 7.94732 13.1466 7.85355C13.0528 7.75979 13.0001 7.63261 13.0001 7.5C13.0001 7.36739 13.0528 7.24021 13.1466 7.14645C13.2403 7.05268 13.3675 7 13.5001 7C13.6327 7 13.7599 7.05268 13.8537 7.14645C13.9474 7.24021 14.0001 7.36739 14.0001 7.5C14.0001 7.63261 13.9474 7.75979 13.8537 7.85355C13.7599 7.94732 13.6327 8 13.5001 8Z",
      fill: "#555555",
      class: s(["svg__fill--medium-grey", "svg__stroke--medium-grey"]),
      stroke: "#555555",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ]);
}
const d = { render: n };
export {
  d as default,
  n as render
};
